import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import styles from './LoadingPage.module.scss';
export const LoadingPage = () => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.container, children: [_jsx(LoadingIcon, {}), _jsx("p", { children: t('common.loading') })] }));
};
